import React, { useState, useEffect } from "react";
import qs from "query-string";

import { Page } from "components/common";
import { ApiClient } from "services";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "reactstrap";

export const XeroConnect = ({ location }) => {
  const [client] = useState(() => ApiClient());
  const [error, setError] = useState();
  const { search } = location;
  const { t } = useTranslation();

  useEffect(
    () =>
      (async () => {
        const { state: organisationId } = qs.parse(search);

        try {
          await client.post(
            `connected_organisations/${organisationId}/confirm_connection`,
            { uri: window.location.href }
          );
          window.location.replace(`/organisations/${organisationId}`);
        } catch (ex) {
          const code = ex.response?.data?.code;

          if (code === "duplicate_organisation") {
            setError(
              t(
                "You already have an organisation connected to this Xero account."
              )
            );
          } else if (code === "XeroTenantError") {
            setError(
              t(
                "You must explicitly select an organisation you want to connect to"
              )
            );
          } else {
            throw ex;
          }
        }
      })(),
    []
  );

  return (
    <Page title="Xero Connect">
      {error ? (
        <Alert color="danger">{error}</Alert>
      ) : (
        <Trans>Loading...</Trans>
      )}
    </Page>
  );
};
